export const locationCardComponent = {
  key: 'locationCardComponent',
  name: 'Location Card Dept-Component',
  siteIdentifier: 'global',

  learnMoreLink: 'Learn More',
};
